"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var TransactionRequest_1 = require("../../TransactionRequest");
var EthereumContractCallExecutionRequest = /** @class */ (function (_super) {
    tslib_1.__extends(EthereumContractCallExecutionRequest, _super);
    function EthereumContractCallExecutionRequest() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputs = [];
        return _this;
    }
    return EthereumContractCallExecutionRequest;
}(TransactionRequest_1.TransactionRequest));
exports.EthereumContractCallExecutionRequest = EthereumContractCallExecutionRequest;
//# sourceMappingURL=EthereumContractCallExecutionRequest.js.map